<template>
    <tr class="table-sub-row creative-row">
        <td :colspan="_isAdvertiser ? 3 : 3" class="cell-spacer"></td>
        <td colspan="4">
            <!--<status-icon :status="creative.status" />-->
            <div class="d-flex align-items-center pl-5">
                <!--                <div class="creative-thumbnail mr-3">-->
                <!--                    <display-media-->
                <!--                        v-if="creative.media && creative.media.length"-->
                <!--                        :media="creative.media[0]"-->
                <!--                        :width="35"-->
                <!--                        :height="35"-->
                <!--                        :thumbnail="true"-->
                <!--                    ></display-media>-->
                <!--                    <div v-else class="placeholder-thumb tiny"></div>-->
                <!--                </div>-->
                <div>
                    <div class="small">Creative #{{ creativeIndex + 1 }}</div>
                    <small class="text-muted">{{ creative.display_name }}</small>
                </div>
            </div>
        </td>
        <td v-if="_isAdmin">
            <!-- Payment status -->
        </td>
        <td colspan="2">
            <div v-if="!disableActions" class="d-flex justify-content-end align-items-center">
                <!-- Review Button -->
                <button v-if="orderAsset.can && orderAsset.can.review" class="btn btn-sm btn-primary"
                        @click="openReview">Review Creative
                </button>
                <button v-else class="btn btn-sm btn-primary" @click="openViewCreative">View Creative</button>
            </div>
        </td>
    </tr>
</template>

<script>
import StatusIcon from './partials/StatusIcon.vue';

export default {
    name: 'OrdersTableOrderCreative',

    components: {
        StatusIcon,
    },

    props: {
        creative: {
            type: Object,
            required: true,
        },
        creativeIndex: {
            type: Number,
            required: true,
        },
        order: {
            type: Object,
            required: true,
        },
        orderItem: {
            type: Object,
            required: true,
        },
        orderAsset: {
            type: Object,
            required: true,
        },
        disableActions: {
            type: Boolean,
            default: false,
        },
    },

    methods: {
        openViewCreative() {
            this.$emit('open-view-creative', [this.creative.id], this.order.id, false);
        },
        openReview() {
            this.$emit('open-review', [this.creative.id], this.order.id, false);
        },
    },
};
</script>

<style scoped>
.creative-row {
    background-color: #f5f6f7;
}

.creative-thumbnail {
    width: 35px;
    height: 35px;
    overflow: hidden;
}

.placeholder-thumb.tiny {
    width: 35px;
    height: 35px;
    background-color: #dee2e6;
    border-radius: 4px;
}
</style>
